<script>
    import ViewPhotoModal from "./ViewPhotoModal.svelte";
    import ViewVideoModal from "./ViewVideoModal.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import MissingData from "./MissingData.svelte";
    import {onMount} from "svelte";
    import {_} from '../lib/i18n';
    import {navigate} from "svelte-routing";
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";

    export let params = {};
    export let date;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let progress = 0;
    $: progress = analyze ? analyze.storiesProgress : 0;
    let mounted = false;
    $: progress && mounted && initialLoad();

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    onMount(async () => {
        mounted = true;
    });

    const counterIncValue = 10;

    let isLoading = false;
    async function initialLoad() {
        if (progress < 100 || isLoading || items.length > 0) return;

        isLoading = true;
        try {
            await loadMore();
            //analyze.setResults('stories', items);
        } catch (err) {
            console.error(err);
        }
        isLoading = false;
    }

    export let analyze;

    let items = [];
    $: analyze && (items = (analyze.result && analyze.result.stories)  ? analyze.result.stories : []);

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    function onImageError(event) {
        event.target.src = '/spy20-lk/img/image-empty.svg';
    }

    let selectedMedia = {};

    function selectMedia(item) {
        if (isEnabledFreeTrial) {
            gotoTariffs();
            return;
        }
        selectedMedia = item;
    }

    let showPhotoModal = false;
    let showVideoModal = false;

    let showCounter = 12;
    let showShowMore = false;
    $: items && (showShowMore = (items.length === showCounter));
    let isLoadingMore = false;
    async function loadMore() {
        isLoadingMore = true;

        if (params.loadMoreStories instanceof Function) {
            try {
                const newItems = await params.loadMoreStories(analyze.id, 12, items.length, date);
                showCounter += 12;
                items = items.concat(newItems);
            } catch (err) {
                console.error(err);
                isLoadingMore = false;
            }
        }

        isLoadingMore = false;
    }

    //$: date && !isLoadingMore && loadMore();

</script>

{#if !isTemporary}
    {#if (((window.shared.state.language === 'en-US' && items.length > 0) || window.shared.state.language !== 'en-US') && isEnabledFreeTrial)}
        <FreeAccessDataHiddenAlert {params} />
    {/if}
    {#if items.length > 0}

            <div class="feed-item feed-item_stories">
                <div class="feed-item__body">
                    <div class="feed-item__content-wrapper">
                        {#each items as item}
                            {#if Number(item.type) === 1}
                                <div class="feed-item-story-content">
                                    <div class="feed-item-story-content__flag feed-item-story-content__flag_photo">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.75 4.58366L8.75 7.33366C8.75 7.88594 8.30228 8.33366 7.75 8.33366L2.25 8.33366C1.69772 8.33366 1.25 7.88594 1.25 7.33366L1.25 3.91699C1.25 3.36471 1.69772 2.91699 2.25 2.91699L2.625 2.91699C2.93976 2.91699 3.23615 2.7688 3.425 2.51699L3.7625 2.06699C3.95135 1.81519 4.24774 1.66699 4.5625 1.66699L5.52083 1.66699" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.70866 1.66699V2.70866M7.70866 3.75033V2.70866M7.70866 2.70866H6.66699M7.70866 2.70866L8.75033 2.70866" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <ellipse cx="4.99967" cy="5.41667" rx="1.66667" ry="1.66667" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="feed-item-story-content__img-wrapper">
                                        <img src={item.preview} alt="thumbnail"
                                             class="feed-item-story-content__image {isEnabledFreeTrial ? 'blur-content' : ''}"
                                             on:error={onImageError}
                                             on:click={() => {
                                                 selectMedia(item);
                                                 showVideoModal = false;
                                                 showPhotoModal = true;
                                             }}
                                        />
                                    </div>
                                </div>
                            {/if}
                            {#if Number(item.type) === 2}
                                <div class="feed-item-story-content">
                                    <div class="feed-item-story-content__flag feed-item-story-content__flag_video">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.33301 7.91634L3.33301 2.08301L7.91634 4.99967L3.33301 7.91634Z" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="feed-item-story-content__img-wrapper">
                                        <img src={item.preview} alt="preview"
                                             class="feed-item-story-content__image {isEnabledFreeTrial ? 'blur-content' : ''}"
                                             on:error={onImageError}
                                             on:click={() => {
                                                 selectMedia(item);
                                                 showPhotoModal = false;
                                                 showVideoModal = true;
                                             }}
                                        />
                                    </div>
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>
            </div>

        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={loadMore} disabled={isLoadingMore}>
                <LoadingIcon show={isLoadingMore} height="16" width="16" />
                {$_('storiesResult.loadMore')}
            </button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={progress != 100} category="stories" />
    {/if}
{/if}

{#if selectedMedia}
<ViewPhotoModal imageUrl={selectedMedia.preview} imageCreatedAt={new Date(selectedMedia.created_at_epoch * 1000)} bind:show={showPhotoModal} />

<ViewVideoModal videoUrl={selectedMedia.video} videoCreatedAt={new Date(selectedMedia.created_at_epoch * 1000)} bind:show={showVideoModal} />
{/if}

<style>
    .feed-item-story-content__image {
        max-width: 100%;
    }
    .blur-content {
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
</style>